(() => {
  if (window.wistgoEasySellInitial) return;
  window.wistgoEasySellInitial = true;
  const setStyle = (element, property, value) => {
    if (element && (element.style.getPropertyValue(property) !== value || element.style.getPropertyPriority(property) !== 'important')) {
      element.style.setProperty(property, value, 'important');
    }
  };
  let variantPicker = null;
  const restore = () => {
    document.querySelectorAll('main strong').forEach(element => {
      if (element.textContent.trim() === 'Stock limité') setStyle(element, 'color', 'rgb(185, 28, 28)');
    });
    const custom = document.getElementById('es-css');
    if (custom && custom.textContent.includes('COMMANDE PRIVÉE')) {
      const start = custom.textContent.indexOf('#es-form-container');
      if (start !== -1) custom.textContent = custom.textContent.slice(0, start) + '.wl-sticky-order{display:none!important}';
    }
    const form = document.getElementById('es-form');
    variantPicker = document.querySelector('[data-wistgo-easysell-variants]') || variantPicker;
    const variants = variantPicker;
    if (form && variants && !form.contains(variants)) {
      const before = form.querySelector('.es-first_name-group') || form.querySelector('.es-cta-group');
      form.insertBefore(variants, before);
      variants.hidden = false;
      variants.style.padding = '0 0 16px';
    }
    const container = document.getElementById('es-form-container');
    setStyle(container, 'background', 'rgb(255, 255, 255)');
    const button = document.getElementById('es-form-button');
    setStyle(button, 'background', 'rgb(0, 0, 0)');
    setStyle(button, 'border-color', 'rgb(0, 0, 0)');
    setStyle(button, 'color', 'rgb(255, 255, 255)');
  };
  let scheduled = false;
  const observer = new MutationObserver(records => {
    if (scheduled || !records.some(record => record.type === 'childList' || ['es-css', 'es-form-container', 'es-form-button'].includes(record.target.id))) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; restore(); });
  });
  restore();
  observer.observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: ['style']});
  // Use the theme's carousel API for EasySell's Eclat colour selections.
  document.addEventListener('change', event => {
    const select = event.target;
    if (!location.pathname.endsWith('/wistgo-royal-pop-montre-2-en-1-bracelet-pendentif') ||
        !(select instanceof HTMLSelectElement) || !select.id.startsWith('es-offer-variant-')) return;
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const colour = normalize(select.value);
    requestAnimationFrame(() => {
      if (!window.xoCarousel?.goTo) return;
      document.querySelectorAll('main xo-carousel[xo-name^="product-information-"]').forEach(carousel => {
        const slides = Array.from(carousel.querySelectorAll('xo-carousel-thumbnail xo-carousel-slide'));
        const index = slides.findIndex(slide => {
          const alt = slide.querySelector('img')?.alt || '';
          return normalize(alt.split(' — ')[0].replace(/^ÉCLAT POP\s*/i, '')) === colour;
        });
        if (index >= 0) window.xoCarousel.goTo(carousel.getAttribute('xo-name'), index);
      });
    });
  }, true);

})();